<template>
  <div>
    <section id="wrapper">
      <div id="content-wrapper" class="col-xs-12">
        <section id="main">
          <section id="content" class="content_v1">
            <div class="slider-banner clearfix">
              <div class="slider-layout-1">
                <div id="spattributessearch" class="spas-wrap">
                  <div
                    class="searchbackground searchbackground-mobile"
                    style="
                      background-repeat: no-repeat;
                      padding-left: 5px;
                      padding-right: 5px;
                      padding-top: 15px;
                      padding-bottom: 45px;
                      background-color: white;
                      background-position: right 0px bottom 0px;
                      background-size: cover;
                      height: 640px !important;
                    "
                  >
                    <div class="row" style="padding-top: 17px">
                      <div class="row" style="margin-left: 36px">
                        <div class="col-4">
                          <router-link to="/ajouterBlocNote">
                            <img
                              style="width: 60px; margin-left: 6px"
                              src="icons8-note-96.png"
                            />
                          </router-link>
                        </div>
                        <div class="col-4">
                          <router-link to="/ajouterService">
                            <img src="add_service_1.png" />
                          </router-link>
                        </div>
                        <div class="col-4">
                          <router-link to="/ajouter_vid_man">
                            <img src="add_vidange_1.png" />
                          </router-link>
                        </div>
                      </div>
                      <div style="margin-left: 36px" class="row">
                        <div class="col-4">
                          <router-link to="/listes_bloc_note">
                            <img style="width: 93%" src="note_m.png" />
                          </router-link>
                        </div>
                        <div class="col-4">
                          <router-link to="/listes_societe">
                            <img
                              style="width: 67px; margin-left: -6px"
                              src="https://img.icons8.com/ios/100/000000/new-company.png"
                            />
                          </router-link>
                        </div>
                        <div class="col-4">
                          <router-link to="/Statistiques">
                            <img
                              style="width: 78px; margin-left: -16px"
                              src="https://img.icons8.com/color/96/000000/analytics.png"
                            />
                          </router-link>
                        </div>
                      </div>
                      <!--  -->
                      <div hidden style="margin-left: 36px" class="row">
                        <div class="col-6">
                          <router-link to="/ajout_matr">
                            <img
                              style="
                                width: 106%;
                                margin-left: -2px;
                                margin-top: 11px;
                              "
                              src="imma.png"
                            />
                          </router-link>
                        </div>
                        <div class="col-4">
                          <router-link to="/ajout_societe">
                            <img
                              style="width: 65px; margin-left: 11px"
                              src="https://img.icons8.com/color/96/000000/new-company.png"
                            />
                          </router-link>
                        </div>
                        <!--  <div class="col-4"></div> -->
                      </div>
                    </div>

                    <div class="row" style="padding-top: 15px">
                      <div class="col-xs-0 col-sm-0 col-md-2 col-lg-4"></div>

                      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-4">
                        <div
                          class="tab-content"
                          style="
                            background-color: #555250c4;
                            border: 0px solid #f8c635;
                            border-top: 0px;
                            border-radius: 0px 0px 5px 5px;
                            box-shadow: 0px 1px 5px 2px #f8c635;
                          "
                        >
                          <div
                            class="tab-pane active"
                            id="bloc-search-with-reg"
                            aria-expanded="true"
                          >
                            <div
                              class="row"
                              style="
                                padding: 0px 0px 0px 0px;
                                text-align: center;
                                margin: auto;
                              "
                            >
                              <form
                                method="get"
                                action=""
                                onsubmit="return mySubmitFunction(event,'registration')"
                                class="spas-form spas-form-center"
                                style=""
                              >
                                <div
                                  style="padding: 20px 0px 0px; margin: auto"
                                  class=""
                                >
                                  <div
                                    class="row"
                                    style="
                                      padding-bottom: 20px;
                                      width: 298px;
                                      padding-top: 10px;
                                      margin: auto;
                                    "
                                  >
                                    <div
                                      class=""
                                      title=""
                                      id="77_chosen"
                                      style="color: white"
                                    >
                                      <a
                                        class=""
                                        onclick="showTypeSerie()"
                                        style="display: none"
                                      >
                                        <div>
                                          <b
                                            style="
                                              background-position: 0px center;
                                            "
                                          ></b>
                                        </div>
                                      </a>
                                    </div>
                                  </div>

                                  <div
                                    style="padding-bottom: 10px; display: block"
                                    id="blockMatTU"
                                  >
                                    <div
                                      style="
                                        height: 57px;
                                        width: 272px;

                                        background-image: url('matricule_moez.png');
                                        position: relative;
                                        margin: auto;
                                      "
                                    >
                                      <input
                                        placeholder="* * *"
                                        v-model="c1"
                                        type="text"
                                        id="numSerie"
                                        min="1"
                                        max="999"
                                        maxlength="3"
                                        style="
                                          display: inline;
                                          width: 80px;
                                          top: 6px;
                                          position: absolute;
                                          left: 25px;
                                          border-radius: 5px;
                                          font-weight: bold;
                                          background-color: rgba(0, 0, 0, 0);
                                          color: white;
                                          font-size: 24px;
                                          border: none;
                                        "
                                        data-com.bitwarden.browser.user-edited="yes"
                                      />
                                      <input
                                        required
                                        placeholder="* * * * "
                                        v-model="c2"
                                        type="text"
                                        id="numCar"
                                        min="1"
                                        max="9999"
                                        maxlength="4"
                                        style="
                                          display: inline;
                                          width: 100px;
                                          top: 6px;
                                          position: absolute;
                                          right: 13px;
                                          border-radius: 5px;
                                          font-weight: bold;
                                          background-color: rgba(0, 0, 0, 0);
                                          color: white;
                                          font-size: 24px;
                                          border: none;
                                        "
                                        data-com.bitwarden.browser.user-edited="yes"
                                      />
                                    </div>
                                  </div>

                                  <!--  <label
                                    class="error-msg"
                                    id="error-mat"
                                    style="
                                      color: rgb(251, 251, 251);
                                      font-weight: bold;
                                      text-shadow: rgb(255, 0, 0) 2px 2px;
                                    "
                                    ><i class="fa fa-info-circle"></i> La
                                    matricule n’a pas été trouvée.</label
                                  > -->

                                  <div
                                    style="
                                      width: 272px;
                                      color: #000000 !important;
                                      margin: auto;
                                    "
                                    class="spas-btn"
                                  >
                                    <div class="spas-attr-inner cf">
                                      <router-link
                                        name="recherche"
                                        :to="{
                                          name: 'res',
                                          query: { search: res_search },
                                        }"
                                      >
                                        <button
                                          class="btn btn-search"
                                          data-type="private"
                                          style="
                                            background-color: #f8c635 !important;
                                            color: #000000 !important;
                                            font-size: 16px !important;
                                          "
                                          name="btn-search-mat"
                                        >
                                          <i
                                            style="color: #fff"
                                            class="fa fa-search fa-search-auto"
                                          ></i>
                                          <i
                                            style="display: none; color: #fff"
                                            class="fa fa-spinner fa-spin-auto"
                                          ></i>
                                          &nbsp; Recherche
                                        </button>
                                      </router-link>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>

                            <div
                              class=""
                              style="
                                margin: 20px 0px 0px 0px;
                                background-color: #28282994;
                                text-align: center;
                              "
                            >
                              <!-- <span style="color: #f8c635"
                                ><i
                                  >1<sup>&nbsp;er</sup> site d'identification
                                  des pièces par Matricule</i
                                ></span
                              > -->
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div>
            <div class="tab-pane active" id="bloc-search-with-reg">
              <div
                class="row"
                style="
                  padding: 0px 0px 0px 0px;
                  text-align: center;
                  margin: auto;
                "
              >
                <form
                  method="get"
                  action=""
                  onsubmit="return mySubmitFunction(event,'registration')"
                  class="spas-form spas-form-center"
                  style=""
                >
                  <div style="padding: 20px 0px 0px; margin: auto" class="">
                    <div
                      id="mat-types-container"
                      class="row"
                      style="
                        padding-bottom: 20px;
                        width: 298px;
                        padding-top: 10px;
                        margin: auto;
                      "
                    >
                      <div
                        class=""
                        title=""
                        id="77_chosen"
                        style="color: white"
                      >
                        <ul class="">
                          <div
                            class="col-sm-6 col-xs-6"
                            style="
                              text-align: left;
                              border-right: #e5d5a8 solid 1px;
                            "
                          >
                            <li
                              class=""
                              id="TU"
                              onclick="getval('TU')"
                              style="
                                font-size: 25px;
                                color: rgb(255, 255, 255);
                                cursor: pointer;
                              "
                            >
                              <i
                                id="TUi"
                                class="fa fa-circle-o"
                                style="margin-right: 10px"
                              ></i
                              ><span style="font-size: 14px"><i>Matr</i></span>
                              TU
                            </li>
                          </div>

                          <div
                            class="col-sm-6 col-xs-6"
                            style="text-align: right"
                          >
                            <li
                              class=""
                              id="RS"
                              onclick="getval('RS')"
                              style="
                                font-size: 25px;
                                cursor: pointer;
                                color: rgb(248, 198, 53);
                              "
                            >
                              <i
                                id="RSi"
                                class="fa fa-dot-circle-o"
                                style="margin-right: 10px"
                              ></i
                              ><span style="font-size: 14px"><i>Matr</i></span>
                              RS
                            </li>
                          </div>
                        </ul>
                        <a
                          class=""
                          onclick="showTypeSerie()"
                          style="display: none"
                        >
                          <span id="typeSerieSelected" name="RS"
                            >Régime suspensif (RS)
                          </span>
                          <div>
                            <b style="background-position: 0px center"></b>
                          </div>
                        </a>
                      </div>
                    </div>

                    <div
                      id="vinverif-text-container"
                      class=""
                      style="
                        text-align: center;
                        margin: auto;
                        margin-bottom: 20px;
                        padding-right: 10px;
                        padding-left: 10px;
                        display: none;
                      "
                    >
                      <span style="color: #ffffff; font-size: 16px"
                        >Veuillez saisir les
                        <strong>deux derniers</strong> caractères du
                        <strong>numéro de chassis</strong> de cette matricule
                        (<a id="backsearch-btn" href="javascript:void 0;"
                          ><u style="color: #f8c634">Page Précédente</u></a
                        >) !</span
                      >
                    </div>

                    <div
                      style="padding-bottom: 10px; display: none"
                      id="blockMatTU"
                    >
                      <div
                        style="
                          height: 57px;
                          width: 272px;
                          background-image: url('matricule_moez.png');
                          position: relative;
                          margin: auto;
                        "
                      >
                        <input
                          placeholder="* * *"
                          type="number"
                          class="form-control no-spin"
                          id="numSerie"
                          min="1"
                          max="999"
                          maxlength="3"
                          style="
                            display: inline;
                            width: 80px;
                            top: 6px;
                            position: absolute;
                            left: 13px;
                            border-radius: 5px;
                            font-weight: bold;
                            background-color: rgba(0, 0, 0, 0);
                            color: white;
                            font-size: 24px;
                          "
                        />
                        <input
                          placeholder="* * * *"
                          type="number"
                          class="form-control no-spin"
                          id="numCar"
                          min="1"
                          max="9999"
                          maxlength="4"
                          style="
                            display: inline;
                            width: 100px;
                            top: 6px;
                            position: absolute;
                            right: 13px;
                            border-radius: 5px;
                            font-weight: bold;
                            background-color: rgba(0, 0, 0, 0);
                            color: white;
                            font-size: 24px;
                          "
                        />
                      </div>
                    </div>
                    <div
                      style="padding-bottom: 10px; display: block"
                      id="blockMatRS"
                    >
                      <div
                        style="
                          height: 57px;
                          width: 272px;
                          background-image: url('rs-mat.png');
                          position: relative;
                          background-repeat: no-repeat;
                          margin: auto;
                        "
                      >
                        <input
                          maxlength="6"
                          placeholder="* * * * * *"
                          type="text"
                          class="form-control"
                          id="numRS"
                          style="
                            display: inline;
                            width: 130px;
                            top: 6px;
                            position: absolute;
                            left: 13px;
                            border-radius: 5px;
                            font-weight: bold;
                            background-color: rgba(0, 0, 0, 0);
                            color: white;
                            font-size: 24px;
                          "
                        />
                      </div>
                    </div>

                    <div
                      id="vinverif-container"
                      style="padding-bottom: 10px; display: none"
                    >
                      <div>
                        <input
                          id="vinverif"
                          placeholder="2 derniers carac du VIN"
                          style="
                            background-color: #3c363699;
                            color: white;
                            font-weight: bold;
                            font-size: 16px;
                            border: 1px solid #8d8886;
                            height: 47px;
                            width: 272px !important;
                            border-radius: 5px;
                            text-transform: uppercase;
                            display: inline-block;
                          "
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>

                    <label
                      class="error-msg"
                      id="error-mat"
                      style="
                        color: rgb(251, 251, 251);
                        font-weight: bold;
                        text-shadow: rgb(255, 0, 0) 2px 2px;
                      "
                      ><i class="fa fa-info-circle"></i> La matricule n’a pas
                      été trouvée.</label
                    >

                    <div
                      id="mat-search-btn-container"
                      style="
                        width: 272px;
                        color: #000000 !important;
                        margin: auto;
                      "
                      class="spas-btn"
                    >
                      <div class="spas-attr-inner cf">
                        <button
                          class="btn btn-search"
                          data-type="private"
                          style="
                            background-color: #f8c635 !important;
                            color: #000000 !important;
                          "
                          name="btn-search-mat"
                        >
                          <i
                            style="color: #fff"
                            class="fa fa-search fa-search-auto"
                          ></i>
                          <i
                            style="display: none; color: #fff"
                            class="fa fa-spinner fa-spin-auto"
                          ></i
                          >Recherche
                        </button>
                      </div>
                    </div>

                    <div
                      id="btn-nextsearch-container"
                      style="
                        width: 272px;
                        color: #000000 !important;
                        margin: auto;
                        display: none;
                      "
                      class="spas-btn"
                    >
                      <div class="spas-attr-inner cf">
                        <button
                          id="nextsearch-btn"
                          class="btn-nextsearch"
                          data-type="private"
                          style="
                            background-color: #f8c635 !important;
                            color: #000000 !important;
                          "
                        >
                          <i
                            style="color: #000; font-size: 18px"
                            class="fa fa-arrow-circle-right fa-search-auto"
                          ></i>
                          Suivant
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div
                class=""
                style="
                  margin: 20px 0px 0px 0px;
                  background-color: #28282994;
                  text-align: center;
                "
              >
                <span style="color: #f8c635"
                  ><i
                    >1<sup>&nbsp;er</sup> site d'identification des pièces par
                    Matricule</i
                  ></span
                >
              </div>

              <div
                class=""
                style="padding: 15px 0px 0px 0px; text-align: center"
              ></div>
            </div>
          </div>

          <footer class="page-footer">
            <!-- Footer content -->
          </footer>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { apiDomain } from "./../config.js";
export default {
  name: "Presentation",
  components: {},
  data() {
    return {
      c1: "",
      c2: "",
      search: "",
    };
  },
  methods: {
    updateValue(event) {
      const value = event.target.value;
      console.log(value, this.amount);
      if (String(value).length <= 3) {
        this.c2 = value;
      }
      this.$forceUpdate();
    },
    addContact() {
      this.axios
        .post(`${apiDomain}/api/submit`, this.contact)
        .then((response) => {
          this.mailPro = "mailto:" + this.emailPanne;
          this.$router.push({ name: "Accueil" });
          this.$noty.success(
            "Votre message a été bien enregistré,nous vous repandrons dés que possible"
          );
        })
        .catch((error) => {
          console.log(error.response.data);
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
  computed: {
    res_search() {
      return (this.search = this.c2 + " " + "TN" + " " + this.c1);
    },
  },
};
</script>

<style>
@media screen and (max-width: 700px) {
  .carbrands-mobile {
    margin-top: 0px !important;
  }
}

div.sp-manu-slider .item {
  padding: 20px 0;
  text-align: center;
  border-right: 0px;
}

div.sp-manu-slider {
  direction: ltr;
  position: relative;
  border: 0px;
}
</style>

<style>
div.spas-btn .btn.btn-search:before {
  display: none !important;
}

.fa-spin-auto {
  margin-left: -12px;
  margin-right: 8px;
}

.fa-search-auto {
  margin-left: -12px;
  margin-right: 8px;
}

.dropdown-style {
  background-color: #3c363699 !important;
  color: white !important;
  font-weight: bold !important;
  font-size: 16px !important;
}
</style>
                <style>
.grecaptcha-badge {
  display: none !important;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-link.active:focus,
.nav-tabs .nav-link.active:hover,
.nav-tabs .nav-item.open .nav-link,
.nav-tabs .nav-item.open .nav-link:focus,
.nav-tabs .nav-item.open .nav-link:hover {
  background-color: #211a18a6;
  border-color: #f8c635 #f8c635 transparent;
}

.nav-tabs {
  border-bottom: 1px solid #f8c635;
}

.spas-form-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.carmodel-style {
  width: 70% !important;
  padding-bottom: 4px !important;
  color: black;
}

@media screen and (max-width: 700px) {
  .searchbackground-mobile {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 18%,
      rgba(248, 198, 52, 1) 50%,
      rgba(255, 255, 255, 1) 83%
    ) !important;
    background-image: none;
  }
}

.searchbackground {
  background-image: url("/themes/sp_autostore/modules/spattributessearch/views/img/backgroundsearch.png");
}

@media screen and (max-width: 700px) {
  .header-mobile {
    text-shadow: 2px 2px #131315 !important;
    color: #f8c634 !important;

    margin: 1px;
  }
}
</style>

                      <style>
.as_cat_box {
  box-shadow: #505247 6px 6px 10px 1px;
  border-radius: 15px !important;
}

div.hot-categories .title-html h3.block-title:before,
div.hot-categories .title-html h3.block-title:after {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: black;
  top: auto;
  bottom: 15px;
}

div.hot-categories .cat .img {
  width: 40%;
  padding-right: 10px;
  padding-left: 5px;
  text-align: center;
}

div.hot-categories .cat .img,
div.hot-categories .cat .info {
  display: inline-block;
  font-size: 14px;
  padding: 20px 5px 5px;
  vertical-align: middle;
}
</style>